<template>
  <div class="app-switch" :class="[`app-switch_${size}`]">
    <label class="app-switch__label" :for="_uid" v-if="label">
      {{ label }}
    </label>
    <vs-switch v-model="model" />
  </div>
</template>

<script>
export default {
  name:     "AppSwitch",
  props:    {
    value: {},
    label: {},
    size:  {
      default: "default",
      type:    String,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set( v ) {
        this.$emit('input', v);
        this.$emit('update:danger', false);
      },
    },
  },
};
</script>

<style lang="scss">
.app-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  &__label {
    color: rgba(var(--app-label-color), 1);
    font-size: 1rem;
    display: block;
    padding-right: 5px;
  }

  .vs-switch-primary.vs-switch-active {
    background: rgba(var(--app-primary), 1);
  }

  &_small {

    .vs-switch {
      width: 34px !important;
      min-width: 34px;
      height: 16px;

      .vs-switch--circle {
        width: 14px;
        height: 14px;
        top: 1px;
      }
    }

    .vs-switch.vs-switch-active:active .vs-switch--circle {
      width: 18px;
      margin-left: calc(100% - 22px);
    }

    .vs-switch.vs-switch-active .vs-switch--circle {
      margin-left: calc(100% - 18px);
    }

  }
}
</style>
